import { render, staticRenderFns } from "./SubUserModal.vue?vue&type=template&id=c2aa2ffc&scoped=true&"
import script from "./SubUserModal.vue?vue&type=script&lang=js&"
export * from "./SubUserModal.vue?vue&type=script&lang=js&"
import style0 from "./SubUserModal.vue?vue&type=style&index=0&id=c2aa2ffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2aa2ffc",
  null
  
)

export default component.exports